export default "__VITE_ASSET__Cu_97dtz__"